<template>
  <div class="dispute-alert__modal">
    <Modal
      :active="true"
      :size="size || messages.messageList ? 'medium' : 'small'"
      @onClose="onClose()">
      <template #header>
        <p>Alert</p>
      </template>
      <template #content>
        <div class="dispute-alert__modal__body">
          <icon size="24" name="exclamation-circle" />
          <div class="dispute-alert__modal__body__content">
            <p>{{ messages.title }}</p>
            <div v-for="message in messages.messageList" :key="message.id">
              <p class="dispute-alert__modal__body__content--p">
                -
                <span class="dispute-alert__modal__body__content--strong">
                  {{ message.title }}
                </span>
                : {{ message.value }}
              </p>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "BulkAlertMessageModal",
  props: {
    messages: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: "small",
    },
  },
  methods: {
    onClose() {
      this.$emit("onModalClose");
    },
  },
};
</script>

<style lang="scss">
.dispute-alert__modal {
  .modal--medium {
    height: 380px;
  }

  .modal--small {
    height: 180px;
  }

  & .p-page__modal__window__content {
    padding-top: 0;
  }
  &__body {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;

    &__content {
      margin-left: 1rem;

      &--strong {
        font-family: "Maersk Text Bold";
      }
      &--p {
        margin-top: 1rem;
      }
    }
  }
}
</style>
